import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { HttpService } from '../../services/http/http.service';
import { LoaderService } from '../../services/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { FADE_IN } from '../../util/animations/animation';
import * as moment from 'moment';

/**
 * This component is used to add the activities related to the patient, this is a reusable component, it is called from user detail screen and popup as well
 */
@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.scss'],
  animations: [FADE_IN]
})
export class ActivitiesComponent implements OnInit {
  @Input() patientId;
  activityForm: FormGroup;
  activities = [];
  isShowActivities = true;
  isShowActivitySaveBtn = false;
  loggedInUser;

  constructor(private FB: FormBuilder,
    private httpService: HttpService,
    private loader: LoaderService,
    private toastr: ToastrService) { 
    this.loggedInUser = JSON.parse(localStorage.getItem('tokenInfo')).idTokenPayload || {};
  }

  ngOnInit(): void {
    this.generateActivityForm();
    this.getActivities();
  }

  generateActivityForm(){
    this.activityForm = this.FB.group({
      noteText: ''
    })
  }

  /**
   * This function is used to hide/show activities by clicking on the button
   */
  hideShowDetails(){
    this.isShowActivities = !this.isShowActivities;
  }

  focusIn(event){
    this.isShowActivitySaveBtn = true;
  }

  focusOut(event){
    if(!this.activityForm.value.noteText)
      this.isShowActivitySaveBtn = false;
  }

  /**
   * This function is used to get all the activities from FHIR 
   */
  getActivities() {
    this.loader.show('progress');
    this.httpService.get(`patient/note/${this.patientId}`)
      .subscribe((response: any) => {
        this.activities = this.formatData(response);
        this.loader.hide('progress');
      }, error => {
        this.toastr.warning(error, 'Patients', {
          progressBar: true, timeOut: 3000
        });
      })
  }

  /**
   * This function is used to format the data before binding to the dom
   * @param data 
   */
  formatData(data){
    data.map(x=>{ 
      x.isEdit = false;
      x.editText = x.noteText
    });
    return data;
  }

  /**
   * This function is used to save the activity by calling backend API
   */
  saveNote(){
    let payload: any = this.activityForm.value;
    payload = {
      ...payload,
      patientId: this.patientId
    }
    this.loader.show('progress');
    this.httpService.post('note', payload)
    .subscribe((response: any) => {
        this.loader.hide('progress');
        this.activityForm.reset();
        this.isShowActivitySaveBtn = false;
        this.getActivities()
    }, error =>{
      this.loader.hide('progress');
      this.toastr.warning(error, '', {
        progressBar: true, timeOut: 3000
      });
    })
  }

  /**
   * This function is used to update the particular activity
   * @param data 
   */
  editNote(data){
    const payload = {
      noteText: data.noteText,
      patientId: this.patientId
    }
    this.loader.show('progress');
    this.httpService.post(`note/${data.id}`, payload)
    .subscribe((response: any) => {
       this.loader.hide('progress');
          this.getActivities();
          data.isEdit = false;
    }, error =>{
      this.loader.hide('progress');
      this.toastr.warning(error, '', {
        progressBar: true, timeOut: 3000
      });
    })
  }

  onEditClick(data){
    data.isEdit = true;
  }

  closeEdit(data){
    data.isEdit = false;
    data.noteText = data.editText;
  }

  getDisplayDate(date){
    return moment(date).fromNow();
  }
}
